module.exports = __webpack_public_path__ + "img/under-maintenance.4cd79066.svg";